import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import axios from "axios";
import { Form, Input, Modal } from "antd";
import DivisionAccessFormItem from "../../divisions/DivisionAccessFormItem";
import { axiosErrorHandler, showSuccessNotification } from "../../../../../swzutils";
const WaypointSaveAsSenderReceiverModal = ({ tenantId, open, senderReceiver, onCancel, onSave }) => {
    const [form] = Form.useForm();
    const [saveInProgress, setSaveInProgress] = useState(false);
    const doSave = (code, divisionId) => {
        if (senderReceiver) {
            setSaveInProgress(true);
            const request = {
                ...senderReceiver,
                code,
                divisionId
            };
            axios.post('/admin/v1/sender-receivers/', request)
                .then((response) => {
                showSuccessNotification('Location was successfully saved');
                onSave(response.data);
            })
                .catch(axiosErrorHandler)
                .finally(() => setSaveInProgress(false));
        }
    };
    const onOk = () => {
        form.validateFields()
            .then((formValues) => doSave(formValues.code, formValues.divisionId))
            .catch(console.error); // This has to be present otherwise antd crashes :(
    };
    return (_jsx(Modal, { title: "Save as Saved Location", open: open, onCancel: onCancel, onOk: onOk, confirmLoading: saveInProgress, children: _jsxs(Form, { layout: "vertical", form: form, children: [_jsx(Form.Item, { name: "code", label: "Code/Name", rules: [
                        { required: true, message: 'Please enter a unique code.' },
                        { pattern: /^[0-9a-z\-_]+$/i, message: 'The code should only contain letters, numbers (-) hyphen and (_) underscore' },
                        { max: 30, message: 'Please limit the code to 30 characters.' }
                    ], children: _jsx(Input, {}) }), _jsx(DivisionAccessFormItem, { required: true, tenantId: tenantId, name: "divisionId", allowMultiple: false, canBeRestricted: false })] }) }));
};
export default WaypointSaveAsSenderReceiverModal;
